// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qG86","rightAdornment":"Header_rightAdornment__1hlhR"};